module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.reservation.travel_package_name))]), _vm._v(" "), _c('div', {
    staticClass: "tab-navigation-reservation"
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "white"
    }
  }), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-travel-package',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "voyage"
    }
  })], 1), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-passengers',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("Reizigers")])]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-insurances',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("Verzekeringen")])]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-invoice',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("Factuur")])]), _vm._v(" "), (_vm.isPaid && _vm.showTravelDocuments) ? _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-docs',
        params: {
          reservationId: _vm.reservation.id,
          reservation: _vm.reservation
        }
      }
    }
  }, [_c('span', [_vm._v("Reisdocumenten")])]) : _vm._e(), _vm._v(" "), (_vm.isPaid && _vm.showParticipants) ? _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-participants',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("Deelnemers")])]) : _vm._e(), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-preferences',
        params: {
          reservationId: _vm.reservation.id,
          reservation: _vm.reservation
        }
      }
    }
  }, [_c('span', [_vm._v("Bijzonderheden")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-831ff620"}!./src/templates/reservations/reservation.html
// module id = 547
// module chunks = 1